<template>
  <CModal @closeModalEgreso="mtdClose" @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :centered="true"
    :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <CRow>
      <!-- Tipo de gasto -->
      <CCol xs="12" sm="12" md="12" lg="12" class="mb-3">
        <label class="font-weight-bold">Tipo de Gasto</label>
        <div class="d-flex justify-content-center mt-1" style="gap: 8px;">
          <CButton size="sm" :color="expenseKind === 'fixed' ? 'primary' : 'outline-primary'"
            @click="expenseKind = 'fixed'">
            <i class="fas fa-thumbtack"></i> Gasto Fijo
          </CButton>
          <CButton size="sm" :color="expenseKind === 'variable' ? 'warning' : 'outline-warning'"
            @click="mtd_select_variable">
            <i class="fas fa-random"></i> Gasto Variable
          </CButton>
        </div>
      </CCol>

      <!-- GASTO FIJO: select + botón nuevo -->
      <CCol xs="12" sm="12" md="12" lg="12" class="mb-2" v-if="expenseKind === 'fixed'">
        <label class="font-weight-bold">Gasto Fijo</label>
        <div class="d-flex align-items-center" style="gap: 8px;">
          <div style="flex: 1;">
            <CSelect size="sm" :value.sync="form.fixed_expense_id" :options="fixedExpenseOptions"
              @update:value="onFixedExpenseChange" />
          </div>
          <CButton size="sm" color="success" @click="mtd_open_new_fixed">
            <i class="fas fa-plus"></i> Nuevo
          </CButton>
        </div>
      </CCol>

      <!-- Sub-form nuevo gasto fijo -->
      <CCol xs="12" sm="12" md="12" lg="12" v-if="expenseKind === 'fixed' && showNewFixed" class="mb-2">
        <CCard class="border-success">
          <CCardBody class="py-2">
            <p class="font-weight-bold text-success mb-2">
              <i class="fas fa-plus-circle"></i> Registrar nuevo gasto fijo
            </p>
            <CInput v-model="newFixed.name" label="Nombre" size="sm" placeholder="Ej: Alquiler, Luz, Agua..." />
            <div class="d-flex justify-content-end" style="gap: 6px;">
              <CButton size="sm" color="secondary" @click="showNewFixed = false">
                Cancelar
              </CButton>
              <CButton size="sm" color="success" @click="mtd_save_fixed_expense">
                <i class="fas fa-save"></i> Guardar
              </CButton>
            </div>
          </CCardBody>
        </CCard>
      </CCol>

      <!-- Fecha -->
      <CCol xs="12" sm="6" class="mb-2" v-if="expenseKind === 'fixed'">
        <CInput v-model="form.date" label="Fecha" type="date" size="sm" />
      </CCol>

      <!-- Monto -->
      <CCol xs="12" sm="6" class="mb-2" v-if="expenseKind">
        <CInput v-model="form.amount" label="Monto (S/)" type="number" size="sm" min="0" step="0.01"
          placeholder="0.00" />
      </CCol>

      <!-- Textarea motivo solo para gasto VARIABLE -->
      <CCol xs="12" sm="12" class="mb-2" v-if="expenseKind === 'variable'">
        <CTextarea label="Motivo de egreso" placeholder="Ingrese el motivo..." rows="3" v-model="form.motive" />
      </CCol>

      <CCol v-for="(item, index) in data_methodpayment" v-if="expenseKind === 'variable'" :key="index" sm="4"
        class="mt-1">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <input type="radio" v-model="form.method" :value="item.id" :aria-label="item.name" />
            </div>
          </div>
          <input type="text" class="form-control" :value="item.name" disabled />
        </div>
      </CCol>
    </CRow>


    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
      <CButton class="btn-info" :style="{ color: 'white' }" @click="mtd_save_expense" :disabled="!canSave">
        <i class="fa fa-save"></i>&nbsp;Guardar
      </CButton>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";

export default {
  name: "c-dataegresos-modal",
  components: { CModal },
  props: {
    title: String,
    boo_modal: Boolean,
  },
  data() {
    return {
      expenseKind: null,
      fixedExpenses: [],
      showNewFixed: false,
      newFixed: {
        name: "",
      },
      form: {
        fixed_expense_id: null,
        date: "",
        amount: "",
        motive: "",
        method: null,
      },
      verificBead: false,
      data_methodpayment: [],
      bead: null,
      // types:[],
      // expenses: [],
    };
  },
  computed: {
    fixedExpenseOptions() {
      return [
        { value: null, label: "-- Seleccione --" },
        ...this.fixedExpenses.map((fe) => ({
          value: fe.id,
          label: fe.name,
        })),
      ];
    },
    canSave() {
      if (!this.expenseKind || !this.form.amount) return false;
      if (this.expenseKind === 'fixed') {
        if (!this.form.date || !this.form.fixed_expense_id) return false;
      }
      if (this.expenseKind === 'variable') {
        if (!this.form.motive.trim() || !this.form.method) return false;
      }
      return true;
    },
  },
  watch: {
    boo_modal(val) {
      if (val) {
        this.mtd_load_fixed_expenses();
        this.showBead();
      }
    },
    expenseKind() {
      this.form.fixed_expense_id = null;
      this.form.motive = "";
      this.showNewFixed = false;
    },
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdClose() {
      this.mtd_reset();
      this.$emit("closeModalEgreso");
    },

    mtd_reset() {
      this.expenseKind = null;
      this.showNewFixed = false;
      this.newFixed = { name: "" };
      this.form = { fixed_expense_id: null, date: "", amount: "", motive: "", method: null };
    },

    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/index/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // console.log(response.statusCode);
          if (response.statusCode == 200) {
            this.verificBead = response.data.bead ? true : false;
            this.bead = this.verificBead == true ? response.data.bead : {};
            this.data_methodpayment = [];
            response.data.methodPayment.forEach((arr) => {
              this.data_methodpayment.push(arr);
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    mtd_load_fixed_expenses() {
      const campuId = this.$store.getters.get_campu?.id;
      const companyId = this.$store.getters.get_company?.id;

      if (!campuId || !companyId) {
        console.error("No se encontró campu_id o company_id en el store");
        return;
      }

      this.get({
        url: this.$store.getters.get__url + `/expense/fixed/${campuId}/${companyId}`,
        token: this.$store.getters.get__token,
      })
        .then((res) => {
          this.fixedExpenses = res.data.data ?? [];
        })
        .catch((err) => {
          console.error(err);
          Swal.fire({ title: "Error al cargar gastos fijos", icon: "error" });
        });
    },

    mtd_open_new_fixed() {
      this.showNewFixed = !this.showNewFixed;
      this.newFixed.name = "";
    },

    onFixedExpenseChange(val) {
      this.form.fixed_expense_id = val;
      const found = this.fixedExpenses.find((fe) => fe.id == val);
      this.form.motive = found ? found.name : "";
    },

    mtd_save_fixed_expense() {
      if (!this.newFixed.name.trim()) {
        Swal.fire({ title: "Ingresa un nombre", icon: "warning" });
        return;
      }
      this.post({
        url: this.$store.getters.get__url + "/expense/fixed/store",
        token: this.$store.getters.get__token,
        params: { name: this.newFixed.name },
      })
        .then((res) => {
          const saved = res.data.data;
          this.fixedExpenses.push(saved);
          this.form.fixed_expense_id = saved.id;
          this.form.motive = saved.name;
          this.showNewFixed = false;
          Swal.fire({
            title: "Gasto fijo registrado",
            icon: "success",
            timer: 1200,
            showConfirmButton: false,
          });
        })
        .catch((err) => {
          console.error(err);
          Swal.fire({ title: "Error al guardar gasto fijo", icon: "error" });
        });
    },

    mtd_save_expense() {
      if (!this.canSave) return;
      this.post({
        url: this.$store.getters.get__url + "/expense/store",
        token: this.$store.getters.get__token,
        params: {
          amount: this.form.amount,
          motive: this.form.motive,
          fixed_expense_id: this.expenseKind === 'fixed' ? this.form.fixed_expense_id : null,
          method_payment_id: this.expenseKind === 'variable' ? this.form.method : null,
          campu_id: this.$store.getters.get_campu.id,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if (response.data.state == 0) {
              Swal.fire({
                title: response.message,
                icon: "warning",
                timer: 1200,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Egreso registrado",
                icon: "success",
                timer: 1200,
                showConfirmButton: false,
              });
              this.$emit("savedExpense");
              this.mtdClose();
            }
          }
        })
        .catch((err) => {
          console.error(err);
          Swal.fire({ title: "Error al guardar egreso", icon: "error" });
        });
    },
    // si la caja está abierta
    mtd_select_variable() {
      console.log("verificBead:", this.verificBead, typeof this.verificBead);
      if (!this.verificBead) {
        Swal.fire({
          title: "Caja no abierta",
          text: "Debe abrir la caja antes de registrar un gasto variable.",
          icon: "warning",
          confirmButtonText: "Entendido",
        });
        return;
      }
      this.expenseKind = 'variable';
    },
  },
};
</script>
<style scoped></style>